<template>
  <div>
    <div class="document-container">
      <div class="columns">
        <div class="column is-three-quarters">
          <dm-download-options v-if="batch" :dmobj="batch" :dmobjmatch="batch"
            :dmobjid="batchId" :parentPage.sync="parentPage"/>
        </div>
        <div class="column is-one-quarter">
          <dm-download-history :dmobj="batch" :parentPage="parentPage"/>
        </div>
      </div>
      <div class="document" v-if="parentPage.showExtract">
        <div class="header">
          <es-header>
            <template #header>
              <div class="header-title" v-if="parentPage && parentPage.extractInfo && parentIndex">Extract File({{ ((parentPage.extractInfo.length = parentIndex.length) ? 1 : parentPage.extractInfo.length - parentIndex.length) }})</div>
              <div class="header-title" v-else>Extract File(s)</div>
            </template>
            <template #actions>
              <ul>
                <li class="p-narrow no-border" style="padding:0px">
                  <div class="list-content" style="padding:0px">
                    <a @click=" getRefresh">
                      <font-awesome-icon :icon="['fas', 'sync-alt']" class="lg"/>
                    </a>
                  </div>
                </li>
                <li class="p-narrow no-border">
                  <div class="list-content" v-if="parentPage.extractInfo && showDLLink">
                    <a v-if="parentPage.downloadFileId"
                      :href="buildAllUrl(parentPage.extractName)">
                      Download All
                    </a>
                  </div>
                </li>
              </ul>
            </template>
          </es-header>
        </div>
      <div class="content" >
        <es-loader v-if="loadingGenerateExtract"/>
          <table v-else class="table is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th title="Extract Date">
                  Extract Date
                  <font-awesome-icon :icon="['fas', 'sort']"/>
                </th>
                <th title="Match Type">
                  Match Type
                  <font-awesome-icon :icon="['fas', 'sort']"/>
                </th>
                <th title="Location Info">
                  Location Info
                  <font-awesome-icon :icon="['fas', 'sort']"/>
                </th>
                <th title="Record Count">
                  Record Count
                  <font-awesome-icon :icon="['fas', 'sort']"/>
                </th>
                <th title="Extract Name">
                  Extract Name
                  <font-awesome-icon :icon="['fas', 'sort']"/>
                </th>
                <th title="Extract Status">
                  Extract Status
                  <font-awesome-icon :icon="['fas', 'sort']"/>
                </th>
                <th title="Actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="parentPage.extractInfo && ((showParent && extract.parent)
                  || (showParent && !extract.parent)
                  || (!showParent && !extract.parent)
                  || parentPage.extractInfo.length === 1)"
                  v-for="extract in parentPage.extractInfo" :key="extract.identifier">
                <td>
                  <div v-if="extract.extractDate">
                    <div  class="has-text-weight-bold">
                      {{ extract.extractDate | formatDateMMDDYYYY }}
                    </div>
                    <div class="has-text-grey-light">
                      {{ extract.extractDate | formatTime }}
                    </div>
                  </div>
                  <div v-else>
                    &nbsp;
                  </div>
                </td>
                <td>
                  <div class="has-text-weight-bold">
                    {{ batch.program.description }}
                  </div>
                </td>
                <td>
                  <div class="is-flex flex-direction--column">
                    <div v-if="!batch.districtCode && !batch.schoolCode" class="is-flex">
                      <b style="font-size:14px">State Batch</b>
                    </div>
                    <div v-else>
                      <router-link
                        :to="{
                          name: 'DmDistrictInfoDetails',
                          params: { code: batch.district.code  },
                        }"
                        class="has-text-weight-bold has-text-primary" style="font-size:14px">
                        {{ batch.district.location.name }}
                      </router-link>
                      <span class="padding-left--small has-text-grey">({{ batch.district.code }})</span>
                      <div v-if="batch.school">
                        <router-link
                          :to="{
                            name: 'DmSchoolInfoDetails',
                            params: {
                              districtCode: batch.district.code,
                              schoolCode: batch.school.code,
                            },
                          }"
                          class="is-italic">
                          {{ batch.school.location.name }}
                        </router-link>
                        <span class="padding-left--small has-text-grey is-italic">({{ batch.school.code }})</span>
                      </div>
                      <div v-else>
                        <span class="is-italic has-text-grey">All Schools</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="table-action">
                  <div class="has-text-weight-bold">
                  {{ extract.processedCount }} of {{ extract.totalCount }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ extract.fileName }}
                  </div>
                </td>
                <td>
                  <div class="has-text-weight-bold" v-if="extract.status">
                    {{ String(extract.status) | statusDescription }}
                  </div>
                  <div class="has-text-weight-bold" v-else>
                    QUEUED
                  </div>
                </td>
                <td class="action">
                  <div v-if="(extract.status === 3 || extract.status === 4) && extract.processedCount > 0 && hasModule('DRMCH:DWNLD:DOWNLOAD')">
                    <a v-if="extract.fileId"
                      :href="buildSplitUrl(extract.fileId, extract.fileName)">
                      Download
                    </a>
                  </div>
                  <div v-else-if="(extract.status === 3 || extract.status === 4) && extract.processedCount === 0 && hasModule('DRMCH:DWNLD:DOWNLOAD')">
                      Download
                  </div>
                  <div v-else>
                    <a @click=" getRefresh">
                      Refresh
                    </a>
                  </div>
                </td>
              </tr>
              <tr v-if="!parentPage.extractInfo">
                <td>
                  <div v-if="parentPage.extractDate">
                    <div  class="has-text-weight-bold">
                      {{ this.parentPage.extractDate | formatDateMMDDYYYY }}
                    </div>
                    <div class="has-text-grey-light">
                      {{ this.parentPage.extractDate | formatTime }}
                    </div>
                  </div>
                  <div v-else>
                    &nbsp;
                  </div>
                </td>
                <td>
                  <div class="has-text-weight-bold">
                    QUEUED
                  </div>
                </td>
                <td>
                  QUEUED
                </td>
                <td class="table-action">
                  <div class="has-text-weight-bold">
                   of
                  </div>
                </td>
                <td>
                  <div>
                    {{ parentPage.extractName }}.TXT
                  </div>
                </td>
                <td>
                  <div class="has-text-weight-bold">
                    QUEUED
                  </div>
                </td>
                <td class="action">
                  <div>
                    <a @click=" getRefresh">
                      Refresh
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <iframe ref="downloadFrame" title="Download - Extract File"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
} from '@fortawesome/pro-solid-svg-icons';
import DmDownloadOptions from '@/components/DmDownloadOptions.vue';
import DmDownloadHistory from '@/components/DmDownloadHistory.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsLoader from '@/components/EsLoader.vue';
import PermissionManager from '@/mixins/PermissionManager';
import { mapGetters } from 'vuex';

library.add(
  faPoll,
  faFileEdit,
  faSyncAlt,
  faSort,
);
export default {

  components: {
    DmDownloadOptions,
    DmDownloadHistory,
    EsForm,
    EsHeader,
    EsFormActions,
    EsLoader,
  },
  mixins: [PermissionManager],
  props: [
    'batch',
    'batchId',
  ],
  data() {
    return {
      parentPage: {
        url: 'directmatch/batches/download',
        notSearch: true,
        showExtract: false,
        dmatch: true,
        matchStatusSelect: null,
        id: null,
        loading: null,
        loadingError: null,
        userId: null,
        userEmail: null,
        extractName: null,
        extractNameExt: null,
        statDesc: null,
        extractStatus: null,
        downloadFileId: null,
        split: null,
        extractInfo: null,
        parentFileName: null,
        downloadIds: [],
        downloadIdNames: [],
      },
      loadingGenerateExtract: null,
      showParent: null,
      downloadAllFiles: true,
      parentIndex: [],
    };
  },
  created() {
    this.parentPage.split = this.properties['DIRECTMATCH-SPLIT_BATCH_OPTION_FOR_EXTRACTS'];
    this.loadRecentExtract();
  },
  methods: {
    async downloadAll(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    downloadFile(evt) {
      this.$refs.downloadFrame.src = evt.target.href;
    },
    buildAllUrl(extractName) {
      return `${axios.defaults.baseURL}directmatch/batches/downloadall/${extractName}`;
    },
    buildSplitUrl(dlFileId, splitFileName) {
      return `${axios.defaults.baseURL}directmatch/batches/download/${dlFileId}?extractFileName=${splitFileName}`;
    },
    async getRefresh() {
      return (this.parentPage.extractName) ? this.refreshExtract() : this.loadRecentExtract();
    },
    async refreshExtract() {
      try {
        this.loadingGenerateExtract = true;

        this.parentPage.downloadIds = new Array(0);
        this.parentPage.downloadIdNames = new Array(0);
        this.parentIndex = new Array(0);

        const res = await axios.get(`directmatch/batches/extractstatus?extractFileName=${this.parentPage.extractName}`);
        this.parentPage.extractInfo = res.data;

        this.downloadAllFiles = true;

        for (let i = 0; i < this.parentPage.extractInfo.length; i++) {
          if (i === 0) {
            this.parentPage.extractStatus = ""+this.parentPage.extractInfo[i].status;
            this.parentPage.downloadFileId = this.parentPage.extractInfo[i].fileId;
          }

          this.showParent = !(this.parentPage.split === "LEA");

          if (!this.parentPage.extractInfo[i].parent)
            this.downloadAllFiles = this.downloadAllFiles && (this.parentPage.extractInfo[i].status === 3 || this.parentPage.extractInfo[i].status === 4)

          if (this.parentPage.extractInfo[i].status === 3 || this.parentPage.extractInfo[i].status === 4) {
            const inArray = element => element === this.parentPage.extractInfo[i].fileId;
            if (this.parentPage.downloadIds.findIndex(inArray) === -1) {
              this.parentPage.downloadIds.push(this.parentPage.extractInfo[i].fileId);
              this.parentPage.downloadIdNames.push(this.parentPage.extractInfo[i].fileName);
            }
          }
          if (this.parentPage.extractInfo[i].parent) {
            this.parentPage.parentFileName = this.parentPage.extractInfo[i].fileName;
            this.parentIndex.push(i);
          }

          if (this.parentIndex || this.parentIndex != null ) {
            if (this.downloadAllFiles && (this.parentPage.downloadIds.length > 0) && (this.parentPage.downloadIds.length === (this.parentPage.extractInfo.length - this.parentIndex.length))) {
              for (let pi = 0; pi < this.parentIndex.length; pi++) {
                this.parentPage.extractInfo[pi].status = 3;
              }
            }
          }

          if (!this.parentPage.extractInfo[i].processedCount) {
            this.parentPage.extractInfo[i].processedCount = 0;
          }

          if (!this.parentPage.extractInfo[i].totalCount) {
            this.parentPage.extractInfo[i].totalCount = 0;
          }
        }
      } catch (e) {
        this.showNotification('danger', ['An error occured']);
      } finally {
        this.loadingGenerateExtract = false;
      }
      this.parentPage.showExtract = true;
    },
    async loadRecentExtract() {
      try {
        this.parentPage.loadingExtract = true;

        const responses = await axios.get(`directmatch/search/recentextractstatus?extractFileName=${this.batchId}`);
        if (responses.data) {
          this.parentPage.extractInfo = responses.data;
          this.downloadAllFiles = true;

          this.parentPage.downloadIds = new Array(0);
          this.parentPage.downloadIdNames = new Array(0);
          this.parentIndex = new Array(0);

          for (let i = 0; i < this.parentPage.extractInfo.length; i++) {
            if (i === 0) {
              this.parentPage.extractStatus = ""+this.parentPage.extractInfo[i].status;
              this.parentPage.downloadFileId = this.parentPage.extractInfo[i].fileId;
              this.parentPage.downloadFileId = this.parentPage.extractInfo[i].fileId;
              this.parentPage.processedCount = this.parentPage.extractInfo[i].processedCount;
              this.parentPage.totalCount = this.parentPage.extractInfo[i].totalCount;
            }

            this.showParent = !(this.parentPage.split === "LEA");

            if (!this.parentPage.extractInfo[i].parent)
              this.downloadAllFiles = this.downloadAllFiles && (this.parentPage.extractInfo[i].status === 3 || this.parentPage.extractInfo[i].status === 4)

            if (this.parentPage.extractInfo[i].status === 3 || this.parentPage.extractInfo[i].status === 4) {
              const inArray = element => element === this.parentPage.extractInfo[i].fileId;
              if (this.parentPage.downloadIds.findIndex(inArray) === -1) {
                this.parentPage.downloadIds.push(this.parentPage.extractInfo[i].fileId);
                this.parentPage.downloadIdNames.push(this.parentPage.extractInfo[i].fileName);
              }
            }
            if (this.parentPage.extractInfo[i].parent) {
              this.parentPage.parentFileName = this.parentPage.extractInfo[i].fileName;
              this.parentIndex.push(i);
            }


            if (this.parentIndex || this.parentIndex != null ) {
              if (this.downloadAllFiles && (this.parentPage.downloadIds.length > 0) && (this.parentPage.downloadIds.length === (this.parentPage.extractInfo.length - this.parentIndex.length))) {
                for (let pi = 0; pi < this.parentIndex.length; pi++) {
                  this.parentPage.extractInfo[pi].status = 3;
                }
              }
            }

            if (!this.parentPage.extractInfo[i].processedCount) {
              this.parentPage.extractInfo[i].processedCount = 0;
            }

            if (!this.parentPage.extractInfo[i].totalCount) {
              this.parentPage.extractInfo[i].totalCount = 0;
            }
          }
          this.parentPage.showExtract = true;
        } else {
          this.parentPage.showExtract = false;
        }
      } catch (e) {
        this.showNotification('danger', ['An error occured']);
      } finally {
        this.parentPage.loadingExtract = false;
      }
    },
  },
  filters: {
    statusDescription(value) {
      let stat = "N/A";
      if (value === "0") {
        stat = "PROCESSING";
      } else if (value === "1") {
        stat = "PROCESSING";
      } else if (value === "2") {
        stat = "INTERRUPTED";
      } else if (value === "3") {
        stat = "COMPLETED";
      } else if (value === "4") {
        stat = "DOWNLOADED";
      }

      return stat;
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
      properties: 'propertiesModule/properties',
    }),
    showDLLink() {
      return this.parentPage.extractInfo.every(extract => (extract.status === 3 || extract.status === 4)
        && ((!extract.parent && extract.processedCount > 0)
        || (extract.parent && extract.processedCount === 0 && this.parentPage.extractInfo.length > 1)));
    },
  },
};
</script>
